import type { NodeV2 } from '@vedalib/editor'
import type { Block } from '@vedalib/editor/lib/block'
import type { EditorElement } from '@vedalib/editor/lib/elements'
import { useCallback } from 'react'
import React from 'react'

import AbsolutePortal from 'components/Editor/components/AbsolutePortal'
import { ABSOLUTE_PORTAL_GAP } from 'components/Editor/components/AbsolutePortal/constants'
import { updateBlock } from 'services/Store/Project/actions'
import { useProjectDispatch } from 'services/Store/Project/hooks'
import type { IBlockMode } from 'services/Store/Project/types'

import * as s from './Controls.module.scss'
import Element from './Element'

interface INodeV2ElementControlsProps {
  block: Block
  element: EditorElement
  mode: IBlockMode
  node: NodeV2
}

const NodeV2ElementControls: React.FC<INodeV2ElementControlsProps> = ({
  block,
  node,
  element,
  mode,
}) => {
  const dispatch = useProjectDispatch()
  const onChange = useCallback(
    (value: unknown) => {
      dispatch(updateBlock({ id: block.uuid, name: `elements.${element?.id}.value`, value }))
    },
    [dispatch, block.uuid, element?.id],
  )
  return (
    <AbsolutePortal
      chain='horizontal'
      name='elementControls'
      offset={`${ABSOLUTE_PORTAL_GAP}px 0`}
      placement='bottomLeft'
      recalculatingKey={block}
    >
      <div className={s.controls}>
        <Element block={block} element={element} mode={mode} node={node} onChange={onChange} />
      </div>
    </AbsolutePortal>
  )
}

export default React.memo(NodeV2ElementControls)
